import { render, staticRenderFns } from "./TabFour.vue?vue&type=template&id=5bdd9796&scoped=true&"
import script from "./TabFour.vue?vue&type=script&lang=js&"
export * from "./TabFour.vue?vue&type=script&lang=js&"
import style0 from "./TabFour.vue?vue&type=style&index=0&id=5bdd9796&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdd9796",
  null
  
)

export default component.exports